export default {
  methods: {
    calculatePayroll(i) {
      // console.log('Calculate data', i)
      const no_data = [null, '', undefined, 'null']
      if (!no_data.includes(i.regular_hours) && !no_data.includes(i.hourly_rate)) {
        i.hourly_pay_amount = (parseFloat(i.regular_hours) * parseFloat(i.hourly_rate)).toFixed(2)
      }
      if (!no_data.includes(i.overtime_hours) && !no_data.includes(i.hourly_rate)) {
        i.overtime_pay_amount = (parseFloat(i.overtime_hours) * (parseFloat(i.hourly_rate) * 1.5)).toFixed(2)
      }
      if(
        !no_data.includes(i.residential_revenue) ||
        !no_data.includes(i.residential_bonus) ||
        !no_data.includes(i.commercial_revenue) ||
        !no_data.includes(i.commercial_bonus)) {
          i.revenue_sum = 0
          if (!no_data.includes(i.residential_revenue)) {
            i.revenue_sum += parseFloat(i.residential_revenue)
          }
          if (!no_data.includes(i.residential_bonus)) {
            i.revenue_sum += parseFloat(i.residential_bonus)
          }
          if (!no_data.includes(i.commercial_revenue)) {
            i.revenue_sum += parseFloat(i.commercial_revenue)
          }
          if (!no_data.includes(i.commercial_bonus)) {
            i.revenue_sum += parseFloat(i.commercial_bonus)
          }
          i.revenue_sum = i.revenue_sum.toFixed(2)
      }
      if (!no_data.includes(i.revenue_sum) && !no_data.includes(i.revenue_adjustment) && !no_data.includes(i.revenue_rate) && parseFloat(i.revenue_rate) !== 0) {
        i.performance_bonuse_subtotal = ((parseFloat(i.revenue_sum) + parseFloat(i.revenue_adjustment)) * parseFloat(i.revenue_rate) / 100).toFixed(2)
      }
      if (!no_data.includes(i.performance_bonuse_subtotal) && !no_data.includes(i.hourly_pay_amount)) {
        i.performance_bonuse_total = (parseFloat(i.performance_bonuse_subtotal) - parseFloat(i.hourly_pay_amount) - parseFloat(i.overtime_pay_amount)).toFixed(2)
        if (i.performance_bonuse_total < 0) { i.performance_bonuse_total = parseFloat('0.00').toFixed(2) }
      }
      if (!no_data.includes(i.private_mileage_total) && !no_data.includes(i.mileage_rate)) {
        i.mileage_reimbursement_amount = (parseFloat(i.private_mileage_total) * parseFloat(i.mileage_rate)).toFixed(2)
      }
      if (!no_data.includes(i.holiday) && !no_data.includes(i.hourly_rate)) {
        i.holiday_pay_amount = (parseFloat(i.holiday) * parseFloat(i.hourly_rate)).toFixed(2)
      }
      if (!no_data.includes(i.vacation_hours) && !no_data.includes(i.hourly_rate)) {
        i.vacation_pay_amount = (parseFloat(i.vacation_hours) * parseFloat(i.hourly_rate)).toFixed(2)
      }
      if (!no_data.includes(i.pto_hours) && !no_data.includes(i.hourly_rate)) {
        i.pto_pay_amount = (parseFloat(i.pto_hours) * parseFloat(i.hourly_rate)).toFixed(2)
      }
      if (!no_data.includes(i.number_of_jobs) && !no_data.includes(i.yard_rate)) {
        i.yard_pay_amount = (
          parseFloat(i.number_of_jobs) * parseFloat(i.yard_rate)
        ).toFixed(2);
      }
      if (!no_data.includes(i.fixed_rate)) {
        i.fixed_pay_amount = parseFloat(i.fixed_rate).toFixed(2);
      }
      if (parseFloat(i.revenue_rate) === 0) {
        i.performance_bonuse_subtotal = parseFloat('0.00').toFixed(2)
        i.performance_bonuse_total = parseFloat('0.00').toFixed(2)
      }
      if (
        !no_data.includes(i.mileage_reimbursement_amount) &&
        !no_data.includes(i.hourly_pay_amount) &&
        !no_data.includes(i.overtime_pay_amount) &&
        !no_data.includes(i.holiday_pay_amount) &&
        !no_data.includes(i.vacation_pay_amount) &&
        !no_data.includes(i.pto_pay_amount) &&
        !no_data.includes(i.yard_pay_amount) &&
        !no_data.includes(i.fixed_pay_amount)
      ) {
        i.payroll_summary_subtotal = (
          parseFloat(i.mileage_reimbursement_amount) +
          parseFloat(i.hourly_pay_amount) +
          parseFloat(i.overtime_pay_amount) +
          parseFloat(i.holiday_pay_amount) +
          parseFloat(i.vacation_pay_amount) +
          parseFloat(i.pto_pay_amount) +
          parseFloat(i.yard_pay_amount) +
          parseFloat(i.fixed_pay_amount)
        ).toFixed(2);
      }
      if (!no_data.includes(i.payroll_summary_subtotal)
        && !no_data.includes(i.tips)
        && !no_data.includes(i.performance_bonuse_total)
        && !no_data.includes(i.bonus)
        && !no_data.includes(i.reimbursement)
        && !no_data.includes(i.deduction)
      ) {
        i.complete_total = (
          parseFloat(i.payroll_summary_subtotal)
          + parseFloat(i.tips)
          + parseFloat(i.performance_bonuse_total)
          + parseFloat(i.bonus)
          + parseFloat(i.reimbursement)
          - parseFloat(i.deduction)
        ).toFixed(2)
      }
      return i
    },
    calculateRevenueSum (i) {
      const no_data = [null, '', undefined, 'null']
      if(
        !no_data.includes(i.residential_revenue) ||
        !no_data.includes(i.residential_bonus) ||
        !no_data.includes(i.commercial_revenue) ||
        !no_data.includes(i.commercial_bonus)) {
          i.revenue_sum = 0
          if (!no_data.includes(i.residential_revenue)) {
            i.revenue_sum += parseFloat(i.residential_revenue)
          }
          if (!no_data.includes(i.residential_bonus)) {
            i.revenue_sum += parseFloat(i.residential_bonus)
          }
          if (!no_data.includes(i.commercial_revenue)) {
            i.revenue_sum += parseFloat(i.commercial_revenue)
          }
          if (!no_data.includes(i.commercial_bonus)) {
            i.revenue_sum += parseFloat(i.commercial_bonus)
          }
          i.revenue_sum = i.revenue_sum.toFixed(2)
      }
      return i
    }
  }
}